import React from 'react';
import Header from "../../User/layouts/Header";
import "../styles/pages/home.scss";
import { Typography, Container } from '@mui/material';
import WhatsApp from "../../User/components/WhatsApp";
import Footer from '../layouts/Footer';

const Shippingpolicy = () => {
    return (
        <React.Fragment>
            <Header />
            <section className='about'>
                <Typography variant='h4'>Shipping Policy</Typography>
            </section>
            <section className='faq'>
                <Container maxWidth="xl">
                    <div className='privacy-content'>
                        <Typography variant='h5'>1. Order Processing :</Typography>
                        <Typography><span>Custom Orders:</span> Since each product is tailor-made to your specifications, please allow
                            2-5 business days for order processing before shipment.</Typography>
                        <Typography><span>Pre-Made Products:</span> Orders for ready-made items will be processed within 1-2 business
                            days.</Typography>
                        <Typography>We operate Monday to Saturday and do not process orders on Sundays or public holidays.</Typography>
                    </div>
                    <div className='privacy-content-1'>
                        <Typography variant='h5'>2. Shipping Methods & Delivery Times :</Typography>
                        <Typography>We partner with trusted courier services to ensure reliable and timely delivery. Delivery times vary
                            based on your location:</Typography>
                        <Typography variant='h5'>Domestic Shipping :</Typography>
                        <Typography variant='h6'><span>Standard Shipping :</span> 5-7 business days</Typography>
                        <Typography variant='h6'><span>Express Shipping :</span> 2-3 business days</Typography>
                        <Typography variant='h5'>International Shipping :</Typography>
                        <Typography>Delivery timelines may vary between 7-14 business days, depending on your region and customs
                            clearance.</Typography>
                    </div>
                    <div className='privacy-content-1'>
                        <Typography variant='h5'>3. Shipping Charges :</Typography>
                        <Typography>Domestic Orders :</Typography>
                        <Typography>Orders above ₹2000 qualify for free standard shipping.</Typography>
                        <Typography>A flat fee of ₹150 applies to all orders below ₹2000.</Typography>
                        <Typography variant='h5'>International Orders:</Typography>
                        <Typography>Shipping charges are calculated at checkout based on your location and the weight of the package.</Typography>
                    </div>
                    <div className='privacy-content-1'>
                        <Typography variant='h5'>4. Order Tracking :</Typography>
                        <Typography>Once your order is shipped, you will receive a confirmation email with a tracking number.</Typography>
                        <Typography>You can track your shipment directly on our website or through the courier partner's tracking page.
                        </Typography>
                    </div>
                    <div class='privacy-content-1'>
                        <Typography variant='h5'>5. Address Accuracy :</Typography>
                        <Typography>Please ensure your shipping address is accurate and complete when placing your order.</Typography>
                        <Typography>Tailors4U is not responsible for delays or lost packages due to incorrect addresses.</Typography>
                    </div>
                    <div class='privacy-content-1'>
                        <Typography variant='h5'>6. Delays & Exceptions :</Typography>
                        <Typography>In rare cases, delivery delays may occur due to unforeseen circumstances such as weather conditions,
                            courier service disruptions, or customs clearance for international shipments.</Typography>
                        <Typography>We will keep you updated on the status of your shipment via email or SMS.</Typography>
                    </div>
                    <div class='privacy-content-1'>
                        <Typography variant='h5'>7. Returns & Exchanges :</Typography>
                        <Typography>For information on returns or exchanges, please refer to our Return Policy page. Note that
                            custom-made items are non-returnable unless there is a defect.</Typography>
                    </div>
                </Container>
            </section>
            <WhatsApp />
            <React.Fragment>
                <Footer />
            </React.Fragment>
        </React.Fragment>
    )
}

export default Shippingpolicy;